import React from 'react';
import { Box, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface EmptyStateProps {
  title?: string;
  /** Set to false to hide the icon (e.g. on archived campaigns page). Default true. */
  showIcon?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'No campaigns yet',
  showIcon = true
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        textAlign: 'center',
        padding: '48px'
      }}
    >
      {showIcon && (
        <Box
          sx={{
            width: '120px',
            height: '120px',
            borderRadius: '50%',
            backgroundColor: (theme) => theme.customColors.themeTertiary,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '24px'
          }}
        >
          <AddIcon
            sx={{
              fontSize: '60px',
              color: (theme) => theme.palette.text.secondary
            }}
          />
        </Box>
      )}
      <Typography
        variant="h5"
        sx={{
          fontWeight: '600',
          color: (theme) => theme.customColors.themeNeutralPrimaryColor,
          marginBottom: '8px'
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default EmptyState;
